<template>
  <div class="cargoWarehousingEditAddress">
    <van-form @submit="onSubmit" label-width="120px">
      <van-field
        v-model="form.ReceivingName"
        :label="$t.cargoWarehousing.receivingName"
        :placeholder="$t.meta.input"
        required
        :rules="[
          {
            required: true,
            message: $t.meta.input + ' ' + $t.cargoWarehousing.receivingName,
          },
        ]"
      />

      <van-field
        v-model="form.PhoneNumber"
        :label="$t.cargoWarehousing.contactPhone"
        :placeholder="$t.meta.input"
        required
        :rules="[
          {
            required: true,
            message: $t.meta.input + ' ' + $t.cargoWarehousing.contactPhone,
          },
        ]"
      />

      <van-field
        v-model="form.PostalCode"
        :label="$t.cargoWarehousing.postcode"
        :placeholder="$t.meta.input"
      />

      <van-field
        readonly
        clickable
        :value="country.text"
        :label="$t.cargoWarehousing.country"
        :placeholder="$t.meta.select"
        @click="onShowCountry"
        required
        :rules="[
          {
            required: true,
            message: $t.meta.select + ' ' + $t.cargoWarehousing.country,
          },
        ]"
      />
      <van-field
        readonly
        clickable
        :value="city.text"
        :label="$t.cargoWarehousing.city"
        :placeholder="$t.meta.select"
        @click="onShowCity"
        required
        :rules="[
          {
            required: true,
            message: $t.meta.select + ' ' + $t.cargoWarehousing.city,
          },
        ]"
      />

      <van-field
        v-model="form.ReceivingAddress"
        :label="$t.cargoWarehousing.receivingAddress"
        :placeholder="$t.meta.input"
        type="textarea"
        required
        :rules="[
          {
            required: true,
            message: $t.meta.select + ' ' + $t.cargoWarehousing.receivingAddress,
          },
        ]"
      />

      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit">{{
          $t.meta.submit
        }}</van-button>
      </div>
    </van-form>

    <option-list
      event="showEditAddressCountrys"
      :options="countryList"
      @onSelect="onSelectCountry"
    ></option-list>

    <option-list
      event="showEditAddressCities"
      :options="cityList"
      @onSelect="onSelectCity"
    ></option-list>
  </div>
</template>
<script>
import Vue from "vue";
import { Form, Field, Button, Switch } from "vant";
import OptionList from "@components/optionList/OptionList.vue";

Vue.use(Form).use(Field).use(Button).use(Switch);
export default {
  name: "cargoWarehousingEditAddress",
  components: {
    OptionList,
  },
  data() {
    return {
      countryList: [],
      country: {
        text: "",
        value: "",
      },
      cityList: [],
      city: { text: "", value: "" },
      form: {
        CRId: null,
        ReceivingName: "",
        PhoneNumber: "",
        PostalCode: "",
        CountryId: null,
        CityId: null,
        ReceivingAddress: "",
      },
    };
  },
  created() {
    const query = this.$route.query;
    if (query.Address) {
      this.form = query.Address;
      this.getOptions().then((success) => {
        if (success) this.applyData();
      });
    }
  },
  methods: {
    applyData() {
      //国家
      var country = this.countryList.find((c) => c.value == this.form.CountryId);
      if (country) {
        this.country.text = country.text;
        this.country.value = country.value;
      }
      //城市
      var city = this.cityList.find((c) => c.value == this.form.CityId);
      if (city) {
        this.city.text = city.text;
        this.city.value = city.value;
      }
      this.$forceUpdate();
    },
    getOptions() {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        Promise.all([this.getCountryList(), this.getCityList()]).then((success) => {
          if (success) {
            resolve(true);
          }
          this.$commonMethod.hideLoading();
        });
      });
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    onShowCountry() {
      this.$bus.$emit("showEditAddressCountrys", true);
    },
    onSelectCountry(item) {
      this.country.text = item.text;
      this.country.value = item.value;
      this.form.CountryId = item.value;
    },
    onShowCity() {
      this.$bus.$emit("showEditAddressCities", true);
    },
    onSelectCity(item) {
      this.city.text = item.text;
      this.city.value = item.value;
      this.form.CityId = item.value;
    },
    getCountryList() {
      var param = {};
      return new Promise((resolve) => {
        this.$api.customerManagement
          .getCountryList(param)
          .then((res) => {
            this.formatCountry(res.data);
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    formatCountry(countrys) {
      countrys.forEach((item) => {
        let country = {
          text: item.CountryName,
          value: item.CountryId,
        };
        this.countryList.push(country);
      });
    },
    getCityList() {
      var param = {};
      return new Promise((resolve) => {
        this.$api.logisticsManagement
          .getCountryList(param)
          .then((res) => {
            this.formatCity(res.data);
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    formatCity(cities) {
      cities.forEach((item) => {
        let city = {
          text: item.City_cn,
          value: item.Id,
        };
        this.cityList.push(city);
      });
    },
    onSubmit() {
      this.$commonMethod.showLoading();
      var param = this.form;
      this.$api.storage
        .editCustomerReceiving(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.cargoWarehousingEditAddress {
}
</style>
